<template>
  <div class="control-setting">
    <money-cn-control
      v-if="editControl._type === 'money_cn'"
      :control="editControl"
      :sheet="sheet"
    ></money-cn-control>
    <ref-control
      v-else-if="editControl._type === 'ref'"
      ref="refTableControl"
      :control="editControl"
      :sheet="sheet"
      :fields="fields"
      :available-sheets="availableSheets"
    ></ref-control>
    <remark-control
      v-else-if="editControl._type === 'remark'"
      :control="editControl"
    ></remark-control>
    <number-control
      v-else-if="editControl._type === 'number'"
      :control="editControl"
      :sheet="sheet"
      :available-sheet-map="availableSheetMap"
      @checkboxChange="checkboxChange"
    ></number-control>
    <money-control
      v-else-if="editControl._type === 'money'"
      :control="editControl"
      :sheet="sheet"
      :available-sheet-map="availableSheetMap"
      @checkboxChange="checkboxChange"
    ></money-control>
    <gather-control
      v-else-if="editControl._type === 'gather'"
      :control="editControl"
      :old-control="control"
      :fields="fields"
      :sheet="sheet"
      :available-sheet-map="availableSheetMap"
      @checkboxChange="checkboxChange"
    ></gather-control>
    <calc-control
      ref="calcControl"
      v-else-if="editControl._type === 'calc'"
      :control="editControl"
      :fields="fields"
      :sheet="sheet"
      @checkboxChange="checkboxChange"
    ></calc-control>
    <calc-str-control
      v-else-if="editControl._type === 'str_calc'"
      :control="editControl"
      :fields="fields"
      :sheet="sheet"
      @checkboxChange="checkboxChange"
    ></calc-str-control>
    <field-control
      v-else-if="editControl._type === 'field'"
      ref="fieldControl"
      :control="editControl"
      :fields="fields"
      :available-sheets="availableSheets"
      @checkboxChange="checkboxChange"
    ></field-control>
    <location-control
      v-else-if="editControl._type === 'location'"
      :control="editControl"
      :sheet="sheet"
      :available-sheet-map="availableSheetMap"
      @checkboxChange="checkboxChange"
    ></location-control>
    <text-control
      v-else-if="editControl._type === 'text'"
      :control="editControl"
      :sheet="sheet"
      :available-sheet-map="availableSheetMap"
      @checkboxChange="checkboxChange"
    ></text-control>
    <telephone-control
      v-else-if="editControl._type === 'telephone'"
      :control="editControl"
      :sheet="sheet"
      :available-sheet-map="availableSheetMap"
      @checkboxChange="checkboxChange"
    ></telephone-control>
    <mail-control
      v-else-if="editControl._type === 'mail'"
      :control="editControl"
      @checkboxChange="checkboxChange"
    ></mail-control>
    <code-control
      v-else-if="editControl._type === 'code'"
      :control="editControl"
      :sheet="sheet"
      :available-sheet-map="availableSheetMap"
    ></code-control>
    <file-control
      v-else-if="editControl._type === 'file'"
      :control="editControl"
      :sheet="sheet"
      :available-sheets="availableSheets"
    ></file-control>
    <progress-control
      v-else-if="editControl._type === 'progress'"
      :control="editControl"
    ></progress-control>
    <rate-control
      v-else-if="editControl._type === 'rate'"
      :control="editControl"
      @checkboxChange="checkboxChange"
    ></rate-control>
    <check-control v-else-if="editControl._type === 'check'" :control="editControl"></check-control>
    <url-control
      v-else-if="editControl._type === 'url'"
      :control="editControl"
      @checkboxChange="checkboxChange"
    ></url-control>
    <sign-control v-else-if="editControl._type === 'sign'" :control="editControl"></sign-control>
    <rich-control v-else-if="editControl._type === 'rich'" :control="editControl"></rich-control>
    <sn-control
      v-else-if="editControl._type === 'sn'"
      :control="editControl"
      :fields="fields"
      @checkboxChange="checkboxChange"
    ></sn-control>
    <area-control
      v-else-if="editControl._type === 'area'"
      :control="editControl"
      :sheet="sheet"
      :available-sheet-map="availableSheetMap"
      @checkboxChange="checkboxChange"
    ></area-control>
    <company-control
      v-else-if="editControl._type === 'company'"
      :control="editControl"
      :sheet="sheet"
      :available-sheet-map="availableSheetMap"
      :decorated-sheet="decoratedSheet"
      @checkboxChange="checkboxChange"
    ></company-control>
    <department-control
      v-else-if="editControl._type === 'department'"
      :control="editControl"
      :sheet="sheet"
      :available-sheet-map="availableSheetMap"
      @checkboxChange="checkboxChange"
    ></department-control>
    <staff-control
      v-else-if="editControl._type === 'staff'"
      :control="editControl"
      :sheet="sheet"
      :available-sheet-map="availableSheetMap"
      :decorated-sheet="decoratedSheet"
      @checkboxChange="checkboxChange"
    ></staff-control>
    <option-control
      v-else-if="editControl._type === 'option'"
      :control="editControl"
      :sheet="sheet"
      :available-sheet-map="availableSheetMap"
      :available-sheets="availableSheets"
      @checkboxChange="checkboxChange"
    ></option-control>
    <time-control
      v-else-if="editControl._type === 'time'"
      :control="editControl"
      :sheet="sheet"
      :available-sheet-map="availableSheetMap"
      @checkboxChange="checkboxChange"
    ></time-control>
    <chart-control
      v-else-if="editControl._type === 'chart'"
      :control="editControl"
      :sheet="sheet"
      :available-sheets="availableSheets"
    ></chart-control>
  </div>
</template>

<script>
import MoneyCnControl from "./controls/MoneyCnControl"
import RefControl from "./controls/RefControl"
import RemarkControl from "./controls/RemarkControl"
import NumberControl from "./controls/NumberControl"
import MoneyControl from "./controls/NumberControl"
import GatherControl from "./controls/GatherControl"
import CalcControl from "./controls/CalcControl"
import CalcStrControl from "./controls/CalcStrControl"
import FieldControl from "./controls/FieldControl"
import FileControl from "./controls/FileControl"
import { decorateSheet } from "@/utils/sheet"
import LocationControl from "@/views/Backend/AdminEdit/Sheet/Field/detail-setting-content/control-setting/controls/LocationControl"
import TextControl from "@/views/Backend/AdminEdit/Sheet/Field/detail-setting-content/control-setting/controls/TextControl"
import CodeControl from "@/views/Backend/AdminEdit/Sheet/Field/detail-setting-content/control-setting/controls/CodeControl"
import TelephoneControl from "@/views/Backend/AdminEdit/Sheet/Field/detail-setting-content/control-setting/controls/TelephoneControl"
import MailControl from "@/views/Backend/AdminEdit/Sheet/Field/detail-setting-content/control-setting/controls/MailControl"
import ProgressControl from "@/views/Backend/AdminEdit/Sheet/Field/detail-setting-content/control-setting/controls/ProgressControl"
import RateControl from "@/views/Backend/AdminEdit/Sheet/Field/detail-setting-content/control-setting/controls/RateControl"
import CheckControl from "@/views/Backend/AdminEdit/Sheet/Field/detail-setting-content/control-setting/controls/CheckControl"
import UrlControl from "@/views/Backend/AdminEdit/Sheet/Field/detail-setting-content/control-setting/controls/UrlControl"
import SignControl from "@/views/Backend/AdminEdit/Sheet/Field/detail-setting-content/control-setting/controls/SignControl"
import RichControl from "@/views/Backend/AdminEdit/Sheet/Field/detail-setting-content/control-setting/controls/RichControl"
import SnControl from "@/views/Backend/AdminEdit/Sheet/Field/detail-setting-content/control-setting/controls/SnControl"
import AreaControl from "@/views/Backend/AdminEdit/Sheet/Field/detail-setting-content/control-setting/controls/AreaControl"
import CompanyControl from "@/views/Backend/AdminEdit/Sheet/Field/detail-setting-content/control-setting/controls/CompanyControl"
import DepartmentControl from "@/views/Backend/AdminEdit/Sheet/Field/detail-setting-content/control-setting/controls/DepartmentControl"
import StaffControl from "@/views/Backend/AdminEdit/Sheet/Field/detail-setting-content/control-setting/controls/StaffControl"
import OptionControl from "@/views/Backend/AdminEdit/Sheet/Field/detail-setting-content/control-setting/controls/OptionControl"
import TimeControl from "@/views/Backend/AdminEdit/Sheet/Field/detail-setting-content/control-setting/controls/TimeControl"
import ChartControl from "@/views/Backend/AdminEdit/Sheet/Field/detail-setting-content/control-setting/controls/ChartControl"

export default {
  name: "control-setting",
  components: {
    CalcStrControl,
    ChartControl,
    TimeControl,
    OptionControl,
    StaffControl,
    DepartmentControl,
    CompanyControl,
    AreaControl,
    SnControl,
    RichControl,
    SignControl,
    UrlControl,
    CheckControl,
    RateControl,
    ProgressControl,
    FileControl,
    MailControl,
    TelephoneControl,
    CodeControl,
    TextControl,
    LocationControl,
    MoneyCnControl,
    RefControl,
    RemarkControl,
    NumberControl,
    MoneyControl,
    GatherControl,
    CalcControl,
    FieldControl
  },
  props: {
    control: Object,
    fields: Array,
    sheet: Object,
    availableSheets: Array
  },
  data() {
    return {
      editControl: {}
    }
  },
  computed: {
    decoratedSheet() {
      return decorateSheet(this.sheet)
    },
    availableSheetMap() {
      return this.availableSheets.reduce((acc, cur) => {
        if (cur.sheets?.length) cur.sheets.forEach(sheet => (acc[sheet.sheetId] = sheet))
        return acc
      }, {})
    }
  },
  methods: {
    init() {
      this.editControl = this.initialProps(this.control)
    },
    // 初始化相关属性
    initialProps(control) {
      this.$set(control, "_hideAttrs", [])
      if (!["option", "select"].includes(control._type)) {
        if (!this._.isObject(control.defaultVal)) {
          control.defaultVal = {}
        }
      }
      switch (control._type) {
        case "option":
          if (control.oneFlag) {
            control._hideAttrs.push("countLimit")
          } else {
            control._hideAttrs = control._hideAttrs.filter(attr => attr !== "countLimit")
          }
          if (!control.likeSelect) {
            control._hideAttrs.push("hint", "allowAdd")
          } else {
            control._hideAttrs = control._hideAttrs.filter(
              attr => !["hint", "allowAdd"].includes(attr)
            )
          }
          break
        case "ref":
          delete control.hint
          break
        case "sn":
          if (!control.key) {
            this.$set(control, "key", "")
          }
          this.$set(control, "preview", "")
          break
        case "chart":
          if (!control.chartId) {
            this.$set(control, "chartId", "")
          }
          this.$set(control, "preview", "")
          if (!control.height) {
            this.$set(control, "height", 400)
          }
          break
      }
      return control
    },
    checkboxChange(attr, value) {
      if (attr === "main" && value) {
        this.editControl.required = true
        this.editControl.display = true
        // 如果当前控件已创建,则type为控件id,否则,为临时id(code).
        let type = this.control._cid ? "_cid" : "code"
        // 清除除了当前控件之外的所有控件的"主控件"标志位
        this.fields.forEach(field => {
          if (field[type] !== this.control[type]) field.main = false
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.control-setting {
  .el-form {
    padding: 12px 12px 0 0;
  }

  .require-flag {
    display: inline-block;
    height: 32px;
    vertical-align: middle;
    color: red;
    font-size: 24px;
    padding-right: 2px;
  }

  .ref-one-flag-row {
    display: flex;
    align-items: center;
    height: 40px;

    .icon-tip {
      margin-left: 12px;
      line-height: 40px;
      font-size: 20px;
      color: #bdbdbd;
      min-width: 30px;
      text-align: center;
      cursor: pointer;
    }
  }

  .switchStyle {
    ::v-deep span {
      height: 18px;
      width: 38px;
    }

    ::v-deep span::after {
      height: 14px;
      width: 14px;
    }
  }
}
</style>
